import * as React from "react";
import { useNavigate } from "react-router-dom";
import { alpha } from "@mui/material/styles";
import {
  Autocomplete,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TablePagination,
  TableRow,
  Toolbar,
  TableSortLabel,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Paper,
  InputAdornment,
  ListItemAvatar,
  ListItemText,
  TextField,
  Select,
  MenuItem,
  OutlinedInput,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Checkbox,
  Button,
  Menu,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import { getDateTime } from "../../../utils/data";
import { useContext, useEffect, useState } from "react";
import {
  getFirstAndLastLetters,
  getPriorityColor,
  renderStatusColorCss,
  statusList,
} from "../../../utils/common/common";

import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { styled } from "@mui/material/styles";
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { appLogger, Http } from "../../../utils";
import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";
import BulkEmailReplyEditor from "./BulkEmailReplyEditor";
import { ROLE_USER_MEMBER } from "../../../model";
import { enableJira, enableZendesk } from "../../../utils/config";
import DeleteDialog from "../../../utils/common/DeleteDialog";
import NameAndEmail from "../../../utils/common/NameAndEmail";
import DateTime from "../../../utils/common/DateTime";
import Badge, { BadgeProps } from "@mui/material/Badge";

const TicketsTable = (props: any) => {
  const {
    tabledata,
    fetchMoreTabledatas,
    fetchMoreRowsPerPageTabledatas,
    isFetching,
    filterLastEvaluatedKey,
    contextProVersion,
    detectDateChange,
    detectFilterApplied,
    tableTitle,
    pageType,
    sortTrigger,
    setChartData,
  } = props;
  const [order, setOrder] = React.useState<Order>("desc");
  const [orderBy, setOrderBy] = React.useState<any>("lastModifiedOn");
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [page, setPage] = React.useState(0);
  const [tempage, setTempage] = React.useState(0);

  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [getFullRowDatas, setgetFullRowDatas] = React.useState<any>([]);
  const [feedbackFullDatas, setFeedbackFullDatas] = React.useState<any>();
  const [assignDDOpen, setassignDDOpen] = React.useState<any>({});

  const [showbulkEmailReplyEditor, setshowBulkEmailReplyEditor] =
    React.useState(false);
  const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);

  const handleClose = () => {
    setDeletePopupOpen(false);
  };

  const navigate = useNavigate();

  useEffect(() => {
    setRowsPerPage(10);
    setPage(0);
  }, [contextProVersion, detectDateChange]);

  useEffect(() => {
    setSelected([]);
    setshowBulkEmailReplyEditor(false);
  }, [contextProVersion, detectDateChange, detectFilterApplied]);

  // useEffect(() => {
  //   setData(detectFilterApplied);
  // }, [detectFilterApplied]);
  interface Data {
    id: number;
    calories: number;
    carbs: number;
    fat: number;
    name: string;
    protein: number;
  }

  function createData(
    id: number,
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number
  ): Data {
    return {
      id,
      name,
      calories,
      fat,
      carbs,
      protein,
    };
  }

  const tableItems: any =
    tabledata && tabledata.Items && tabledata.Items.length > 0
      ? tabledata.Items
      : [];
  // [

  //];

  // const tableItems: any =
  //   tableItems1 && tableItems1.length > 0
  //     ? tableItems1.map((e: any) => {
  //         return {
  //           ...e,
  //           isEmailPresent: false,
  //         };
  //       })
  //     : [];
  // console.log(tableItems, "tableItemstableItems");
  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  type Order = "asc" | "desc";

  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  // Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
  // stableSort() brings sort stability to non-modern browsers (notably IE11). If you
  // only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
  // with exampleArray.slice().sort(exampleComparator)
  function stableSort<T>(
    array: readonly T[],
    comparator: (a: T, b: T) => number
  ) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  interface HeadCell {
    disablePadding: boolean;
    id: keyof Data;
    label: string;
    numeric: boolean;
  }

  const headCells: any = [
    {
      id: "id",
      numeric: true,
      disablePadding: false,
      label:
        pageType == "FEEDBACK"
          ? "Feedback Id"
          : pageType == "BUG_REPORT"
          ? "Ticket Id"
          : "Feature Request Id",
      enableSort: false,
      enableColumn: true,
    },
    {
      id: "feedbackComments.generalComment",
      numeric: true,
      disablePadding: false,
      label: pageType == "BUG_REPORT" ? "Subject" : "Comments",
      enableSort: true,
      enableColumn: true,
    },
    {
      id: "productRating",
      numeric: true,
      disablePadding: false,
      label: "Ratings",
      enableSort: true,
      enableColumn: pageType == "FEEDBACK" ? true : false,
    },
    {
      id: "userId",
      numeric: true,
      disablePadding: false,
      label: "Sender Email",
      enableSort: true,
      enableColumn: true,
    },
    {
      id: "status",
      numeric: true,
      disablePadding: false,
      label: "Status",
      enableSort: true,
      enableColumn: true,
    },
    {
      id: "ticketAssignee",
      numeric: true,
      disablePadding: false,
      label: "Assignee",
      enableSort: false,
      enableColumn: true,
    },
    {
      id: "lastModifiedOn",
      numeric: true,
      disablePadding: false,
      label: "Modified date",
      enableSort: true,
      enableColumn: true,
    },
    {
      id: "createdOn",
      numeric: true,
      disablePadding: false,
      label: "Created date",
      enableSort: true,
      enableColumn: true,
    },
    {
      id: "Actions",
      numeric: true,
      disablePadding: false,
      label: "",
      enableSort: false,
      enableColumn: true,
    },
    // {
    //   id: "ticketPlatform",
    //   numeric: true,
    //   disablePadding: false,
    //   label: "Platform",
    // },
  ];

  // interface EnhancedTableProps {
  //   numSelected: number;
  //   onRequestSort: (
  //     event: React.MouseEvent<unknown>,
  //     property: keyof Data
  //   ) => void;
  //   onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  //   order: Order;
  //   orderBy: string;
  //   rowCount: number;
  // }
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const sortDataOrder = property;
    const sortDataOrderBy = isAsc ? "desc" : "asc";
    const pageDatas = {
      page: page + 1,
      rowsPerPage: rowsPerPage,
      sortDataOrder: sortDataOrder,
      sortDataOrderBy: sortDataOrderBy,
    };
    sortTrigger(pageDatas);
    // console.log(property, "order-----------");
    // console.log(isAsc ? "desc" : "asc", "order-----------");
  };

  const [isChecked, setIsChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const EnhancedTableHead = (props: any) => {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler =
      (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
        if (tableItems.length > 0) {
          onRequestSort(event, property);
        }
      };
    const handleSelectAllClick = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      if (event.target.checked) {
        const newSelected =
          tableItems &&
          tableItems.length > 0 &&
          tableItems.map((n: any) => n.id);
        setSelected(newSelected);
      } else {
        setSelected([]);
      }
    };

    const StyledCheckbox = styled("input")(({ theme }) => ({
      // appearance: "none",
      width: "18px",
      height: "18px",
      borderRadius: "1px",
      border: `2px solid #000`,
      cursor: "pointer",
      "& .MuiSvgIcon-root": {
        border: "5px solid #000 !important",
        borderRadius: "4px",
      },
      "&:checked": {
        // backgroundColor: theme.palette.primary.main,
        appearance: "checkbox",
      },
    }));

    const handleCheckboxChange = (event: any) => {
      setTempage(page);
      if (event.target.checked) {
        const data = tableItems.filter(
          (d: any) =>
            d.userId != null &&
            d.userId != undefined &&
            d.userId != "" &&
            d.isEmailPresent
        );
        const newSelected = data.map((n: any) => n.id);
        setSelected(newSelected);
        setIsChecked(true);
      } else {
        setSelected([]);
      }
      return;
    };

    const handleCheckbocSelectAllClick = (event: any) => {
      setTempage(page);
      if (event.target.checked) {
        const data = tableItems.filter(
          (d: any) =>
            d.userId != null &&
            d.userId != undefined &&
            d.userId != "" &&
            d.isEmailPresent
        );
        const newSelected = data.map((n: any) => n.id);
        setSelected(newSelected);
        setIsChecked(true);
        setgetFullRowDatas(tableItems);
      } else {
        setSelected([]);
        setIsChecked(false);
        setgetFullRowDatas([]);
      }
      return;
    };

    useEffect(() => {
      // Set indeterminate state based on numSelected and rowCount
      if (numSelected > 0 && numSelected < rowCount) {
        setIndeterminate(true);
      }
    }, [isChecked]);

    const getCheckedStatus = () => {
      // Get the count of feedback IDs present in both arrays

      const data = tableItems.filter(
        (d: any) =>
          d.userId != null &&
          d.userId != undefined &&
          d.userId != "" &&
          d.isEmailPresent
      );
      const datalength = data && data.length;

      // Match exact feedback IDs from feedbackArray1 that are present in feedbackArray2
      const matchedFeedbacks = selected.filter((id: any) =>
        data.some((obj: any) => obj.id === id)
      );

      return matchedFeedbacks.length != 0 &&
        matchedFeedbacks.length == datalength
        ? true
        : false;
    };
    // useEffect(() => {
    //   sortFunction();
    // }, [order, orderBy]);

    const sortFunction = () => {
      // console.log(order, "order-----------");
      // console.log(orderBy, "order-----------");
      // triggerSortBy()
    };
    const renderSelectAllchkbox = () => {
      if (tableItems) {
        const countEmailPresentWithUserId = tableItems.filter(
          (d: any) =>
            d.userId != null &&
            d.userId != undefined &&
            d.userId != "" &&
            d.isEmailPresent
        ).length;
        if (countEmailPresentWithUserId > 0) {
          return (
            <StyledCheckbox
              id="myCheckbox"
              type="checkbox"
              className="mui-checkbox"
              checked={getCheckedStatus()}
              ref={(el) => {
                if (el) {
                  //  el.indeterminate = numSelected > 0 && numSelected < rowCount;
                }
              }}
              onChange={handleCheckboxChange}
              onClick={handleCheckbocSelectAllClick}
            />
          );
        }
      }
    };
    return (
      <TableHead>
        <TableRow>
          <TableCell sx={{ padding: "15px !important", height: "45px" }}>
            {renderSelectAllchkbox()}
          </TableCell>
          {headCells.map(
            (headCell: any) =>
              headCell.enableColumn && (
                <TableCell
                // key={headCell.id}
                // align={headCell.numeric ? "left" : "left"}
                // padding={headCell.disablePadding ? "none" : "normal"}
                // sortDirection={orderBy === headCell.id ? order : false}
                >
                  {headCell.enableSort ? (
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : "asc"}
                      onClick={createSortHandler(headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  ) : (
                    <>{headCell.label}</>
                  )}
                </TableCell>
              )
          )}
        </TableRow>
      </TableHead>
    );
  };

  const EnhancedTableToolbar = (props: any) => {
    const { numSelected } = props;

    return (
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: "1 1 90%" }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected out of {tabledata?.Count || 0}
          </Typography>
        ) : (
          <>{tableTitle}</>
          // <Typography
          //   sx={{ flex: "1 1 100%" }}
          //   variant="h6"
          //   id="tableTitle"
          //   component="div"
          // >
          //   Nutrition
          // </Typography>
        )}
        {numSelected > 0 ? (
          <Tooltip title="Bulk Reply">
            <Button
              type="button"
              variant="contained"
              sx={{
                textTransform: "uppercase",
                borderRadius: "24px",
                whiteSpace: "nowrap",
              }}
              onClick={BulkEmailReplyAction}
            >
              Bulk Reply
            </Button>
          </Tooltip>
        ) : (
          <></>
          // <Tooltip title="Filter list">
          //   <IconButton>
          //     <FilterListIcon />
          //   </IconButton>
          // </Tooltip>
        )}
      </Toolbar>
    );
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected =
        tableItems && tableItems.length > 0 && tableItems.map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const test: any = [];

  const handleClick = (
    event: React.MouseEvent<unknown>,
    id: number,
    rowdata: any
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    // const feedbackIdsToFilter = newSelected;
    // const filteredFeedback = tableItems.filter((feedback: any) =>
    //   feedbackIdsToFilter.includes(feedback.id)
    // );
    test.push(rowdata);

    setgetFullRowDatas((prevDatas: any) => [...prevDatas, rowdata]);

    setSelected(newSelected);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setIsChecked(false);
    setPage(newPage);
    const pageDatas = {
      page: newPage + 1,
      rowsPerPage: rowsPerPage,
    };
    fetchMoreTabledatas(pageDatas);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    const pageDatas = {
      page: 1,
      rowsPerPage: parseInt(event.target.value, 10),
    };
    fetchMoreRowsPerPageTabledatas(pageDatas);
  };

  const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDense(event.target.checked);
  };

  const isSelected = (id: number) => selected.includes(id);

  // Avoid a layout jump when reaching the last page with empty tableItems.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableItems.length) : 0;
  // const visibleRows = stableSort(
  //   tableItems,
  //   getComparator(order, orderBy)
  // ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  // console.log(visibleRows, "visibleRows-22");

  function getRandomColor() {
    // Generating random hexadecimal color code
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  }
  const redirectTicketReplyPage = (
    data: any,
    type: any,
    fbtype: any,
    productDetails: any
  ) => {
    const pagetype =
      fbtype == "FEEDBACK"
        ? "feedback"
        : fbtype == "BUG_REPORT"
        ? "tickets"
        : "feature";
    navigate(`/${pagetype}/tickets-${type}/${data.id}`, {
      state: {
        productDetails: productDetails,
      },
    });
  };
  const renderSubject__ = (data: any) => {
    const commets: any = data || "{}";
    const subject = typeof commets === "string" ? JSON.parse(commets) : commets;
    return subject?.generalComment || "-";
  };
  const renderSubject = (data: any) => {
    if (!data) return "-";
    if (typeof data === "object") return data?.generalComment || "-";
    if (typeof data === "string") {
      try {
        return JSON.parse(data).generalComment || "-";
      } catch {
        return "-";
      }
    }
    return "-";
  };

  const handleAssignChange = (
    event: React.ChangeEvent<{}>,
    newValue: any,
    rowId: number
  ) => {
    setAssignees((prevAssignees: any) => ({
      ...prevAssignees,
      [rowId]: newValue,
    }));
    const putObj = {
      "id": rowId,
      "assignee": newValue.userId,
    };
    putAssingeeUpdate(putObj);
  };
  const putAssingeeUpdate = (putData: any) => {
    Http.put({
      url: `/api/v2/userFeedback`,
      body: {
        ...putData,
      },
      state: userInfo,
    })
      .then((response: any) => {
        setAssigneeIsloading(false);
        if (response && response.message === "ok") {
          props.snackbarShowMessage(
            "Data updated successfully",
            "success",
            3000
          );
        } else {
          props.snackbarShowMessage("User assigned failed", "error", 3000);
        }
      })
      .catch((error: any) => {
        setAssigneeIsloading(false);
        props.snackbarShowMessage(error.message, "error");
      });
  };
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#2858D3",
    },
  }));
  const renderOption = (props: any, option: any) => {
    <Grid container spacing={2} sx={{ padding: "10px" }}>
      <Grid item xs={12} sm={4} md={4} lg={1.5} xl={1.5}>
        <Avatar
          sx={{
            width: 20,
            height: 20,
            fontSize: 9,
          }}
        >
          {option?.emailId && option.emailId.charAt(0).toUpperCase()}
        </Avatar>
      </Grid>
      <Grid
        sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
        item
        xs={12}
        sm={4}
        md={4}
        lg={8}
        xl={8}
      >
        {option.emailId}
        <BorderLinearProgress variant="determinate" value={50} sx={{ mt: 1 }} />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
        {option.currCount + "/" + option.maxCount}
      </Grid>
    </Grid>;
  };
  const BulkEmailReplyAction = (event: any) => {
    if (getFullRowDatas && getFullRowDatas.length > 0) {
      const uniqueData = getFullRowDatas.filter(
        (obj: any, index: any, self: any) =>
          index === self.findIndex((t: any) => t.id === obj.id)
      );
      const filteredData = uniqueData.filter((obj: any) =>
        selected.includes(obj.id)
      );
      setFeedbackFullDatas(filteredData);
      setshowBulkEmailReplyEditor(true);
    }
  };
  const closeBulkEmailReply = () => {
    setshowBulkEmailReplyEditor(false);
  };
  const { userInfo, enabledFeatures } = useContext(
    UserContext
  ) as UserLoginInfo;
  const [AssigneeIsloading, setAssigneeIsloading] = useState(false);
  const [assigneeOptions, setAssigneeOptions] = useState<any>({});

  const handleAssigneeOpen = async (data: any, rowId: any) => {
    setAssigneeIsloading(true);
    Http.get({
      url: `/api/v2/userAssignment?productId=${data.productId}&productVersion=${data.productVersion}`,
      state: userInfo,
    })
      .then((response: any) => {
        setAssigneeIsloading(false);
        if (
          response &&
          response.userAvailabilityList &&
          response.userAvailabilityList.length > 0
        ) {
          const modify = response.userAvailabilityList;
          const transformedData = modify.map((item: any) => ({
            ...item,
            name: item.emailId, // Use emailId as the name
            value: item.userId, // Use userId as the value
          }));
          setAssigneeOptions({
            ...assigneeOptions,
            [rowId]: transformedData,
          });
          // setassignDDOpen({
          //   ...assigneeOptions,
          //   [rowId]: true,
          // });
        } else {
          // props.snackbarShowMessage("No users / products mapped", "info");
        }
      })
      .catch((error: { message: any }) => {
        setAssigneeIsloading(false);
        props.snackbarShowMessage(error.message, "error");
      });
  };
  const checkandRenderOptions = (assndata: any, rowId: any) => {
    let datass: any = [];
    if (assndata && Object.keys(assndata).length > 0) {
      if (assndata[rowId]) {
        datass = assndata[rowId];
      }
    }
    return datass;
  };

  const renderValues = (val: any) => {
    let obj = { "name": "", "value": "" };
    if (val) {
      obj = { "name": val, "value": val };
    }
    return obj;
  };
  const [assignees, setAssignees] = React.useState<any>({});
  const [feedbackStatus, setfeedbackStatus] = React.useState<any>("");

  const handleStatusChange = (event: any, rowId: number) => {
    setfeedbackStatus((prevStatus: any) => ({
      ...prevStatus,
      [rowId]: event.target.value,
    }));
    const putObj = {
      "id": rowId,
      "status": event.target.value,
    };
    putAssingeeUpdate(putObj);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [currProd, setCurrProd] = useState({} as any);

  const handleMenuOpen = (event: any, rowData: any) => {
    setCurrProd(rowData);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (id: any) => {
    // Handle edit action
    // console.log("Edit:", id);
    handleMenuClose();
  };

  const handleDelete = (id: any) => {
    // Handle delete action
    // console.log("Delete:", id);
    handleMenuClose();
  };

  const deleteFeedback = () => {
    const feedbackId = currProd.id;
    const feedbackMedia = currProd.feedbackMedia;
    // setlo(true);
    appLogger.info(
      {
        infoObj: {
          method: "deleteFeedback",
          component: "feedback",
          fileName: "TicketsTable.tsx",
          request: { feedbackId, feedbackMedia },
        },
      },
      "Delete Feedback data"
    );
    let mediaName;
    if (feedbackMedia) {
      if (feedbackMedia.audio != "") {
        mediaName = feedbackMedia.audio;
      }
      if (feedbackMedia.video != "") {
        mediaName = feedbackMedia.video;
      }
      if (feedbackMedia.file != "") {
        mediaName = feedbackMedia.file;
      }
      if (feedbackMedia.image != "") {
        mediaName = feedbackMedia.image;
      }
    }
    const names = mediaName ? mediaName.split("/") : [];
    Http.deleteReq({
      url:
        names.length > 0
          ? `/api/v2/userFeedback/${feedbackId}/${names[names.length - 3]}/${
              names[names.length - 2]
            }/${names[names.length - 1]}`
          : `/api/v2/userFeedback/${feedbackId}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "deleteFeedback",
            component: "feedback",
            fileName: "TicketsTable.tsx",
            deleteFeedbackResponse: response,
          },
        });
        setDeletePopupOpen(false);
        // setIsloading(false);
        const test = {
          field: "DELETE",
          operation: "contains",
          value: [],
        };

        setChartData(test);
      })
      .catch((error) => {
        setDeletePopupOpen(false);
        // setIsloading(false);
        appLogger.error({
          errObj: {
            method: "deleteFeedback",
            component: "feedback",
            fileName: "TicketsTable.tsx",
            err: error,
          },
        });
      });
  };

  const getSplittedFeedbackId = (rowid: any) => {
    const segments = rowid.split("-");
    const lastSegment = segments.pop();
    return lastSegment;
  };
  const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    "& .MuiBadge-badge": {
      right: -15,
      // top: 13,
      // border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
      background: "#ff4757",
    },
  }));
  return (
    <Box
      sx={{ width: "100%" }}
      className={
        isFetching || AssigneeIsloading ? " chart-item loader" : "chart-item"
      }
    >
      <Paper
        sx={{
          width: "100%",
          mb: 2,
          position: "relative",
          boxShadow: "none",
          border: "1px solid rgba(40, 88, 211, 0.2)",
        }}
      >
        {selected.length > 0 && (
          <EnhancedTableToolbar numSelected={selected.length} />
        )}
        <TableContainer>
          <Table
            className="cuvoTicketsTable"
            sx={{
              minWidth: 750,
              "& .MuiTableCell-root": {
                fontSize: "12px",
                padding: "8px",
                // padding: "8px 0px 8px 15px", // Decrease cell padding
                // fontSize: "0.875rem", // Decrease font size
              },
            }}
            aria-labelledby="tableTitle"
            // size={"small"}
            // size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={tableItems.length}
            />
            <TableBody>
              {tableItems &&
                tableItems.length > 0 &&
                tableItems.map((row: any, index: any) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  function onClose(
                    event: {},
                    reason: "backdropClick" | "escapeKeyDown"
                  ): void {
                    throw new Error("Function not implemented.");
                  }

                  return (
                    <TableRow
                      key={row.id}
                      sx={{
                        cursor: "pointer",
                        // "&:nth-of-type(even)": { backgroundColor: "#F4F7FD" },
                        borderLeft: `3px solid ${getPriorityColor(
                          row.bugPriority != "" &&
                            row.feedbackType != "FEEDBACK" &&
                            row.feedbackType != "FEATURE_REQUEST"
                            ? row.bugPriority.toLowerCase()
                            : row.feedbackType != "FEEDBACK" &&
                              row.feedbackType != "FEATURE_REQUEST"
                            ? "medium"
                            : ""
                        )}`,
                        backgroundColor:
                          row.status == "new" ? "#ffffff" : "#F4F7FD",
                      }}
                      hover
                      // onClick={(event) => handleClick(event, row.id, row)}
                      // onClick={() =>
                      //   redirectTicketReplyPage(
                      //     row,
                      //     "reply",
                      //     row.feedbackType,
                      //     row
                      //   )
                      // }
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      selected={isItemSelected}
                      className={row.status == "new" ? "new" : ""}
                    >
                      <TableCell padding="checkbox">
                        {row.userId && row.isEmailPresent ? (
                          <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                              "aria-labelledby": labelId,
                            }}
                            onClick={(event) => handleClick(event, row.id, row)}
                          />
                        ) : null}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          color: "#2858d3 !important",
                          minWidth: "150px",
                        }}
                        onClick={() =>
                          redirectTicketReplyPage(
                            row,
                            "reply",
                            row.feedbackType,
                            row
                          )
                        }
                      >
                        {row.refId && row.refId.length > 0
                          ? row.refId
                          : getSplittedFeedbackId(row.id)}
                      </TableCell>
                      {/* <TableCell
                      sx={{
                        color: "#2858D3 !important",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      component="th"
                      id={labelId}
                      scope="row"
                      padding="none"
                      onClick={() =>
                        redirectTicketReplyPage(
                          row,
                          "reply",
                          row.feedbackType,
                          row
                        )
                      }
                    >
                      <div
                        title={row.id}
                        style={{
                          margin: "0px",
                          whiteSpace: "nowrap",
                          width: "13em",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {row.id}
                      </div>
                    </TableCell> */}
                      {/* {datas.platformInfo &&
                JSON.parse(datas.platformInfo).platformName ? JSON.parse(datas.platformInfo).platformName : "-"} */}
                      <TableCell
                        align="left"
                        sx={{ minWidth: "230px" }}
                        onClick={() =>
                          redirectTicketReplyPage(
                            row,
                            "reply",
                            row.feedbackType,
                            row
                          )
                        }
                      >
                        {renderSubject(row.feedbackComments)}
                        {row?.notificationCount &&
                        row?.notificationCount != 0 ? (
                          <StyledBadge
                            badgeContent={row?.notificationCount}
                            color="secondary"
                          ></StyledBadge>
                        ) : null}
                        {/* <div className="badge-container">
                        <span className="badge">New</span>
                      </div> */}
                      </TableCell>
                      {row.feedbackType == "FEEDBACK" && (
                        <TableCell
                          align="left"
                          onClick={() =>
                            redirectTicketReplyPage(
                              row,
                              "reply",
                              row.feedbackType,
                              row
                            )
                          }
                        >
                          {row.productRating}
                        </TableCell>
                      )}
                      <TableCell
                        align="left"
                        // sx={{
                        //   fontWeight: "600 !important",
                        // }}
                        onClick={() =>
                          redirectTicketReplyPage(
                            row,
                            "reply",
                            row.feedbackType,
                            row
                          )
                        }
                      >
                        {row.userId ? (
                          <NameAndEmail
                            text={row.userId}
                            useNewLine={true}
                            emailStyle={{ opacity: 0.85, fontWeight: 400 }}
                          />
                        ) : (
                          "Anonymous"
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {(feedbackStatus[row.id] != null &&
                        feedbackStatus[row.id] != "" &&
                        feedbackStatus[row.id] != undefined
                          ? feedbackStatus[row.id] &&
                            ["new", "inprogress", "closed"].includes(
                              feedbackStatus[row.id]
                            )
                          : row?.status &&
                            ["new", "inprogress", "closed"].includes(
                              row?.status
                            )) && (
                          <Select
                            sx={{
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            size="small"
                            labelId="ticketstatus-select"
                            id="ticketstatus-select"
                            value={
                              feedbackStatus[row.id] != null &&
                              feedbackStatus[row.id] != "" &&
                              feedbackStatus[row.id] != undefined
                                ? feedbackStatus[row.id]
                                : row?.status
                                ? row.status
                                : ""
                            }
                            label="platform"
                            onChange={(event: any) =>
                              handleStatusChange(event, row.id)
                            }
                          >
                            {statusList.map((e: any, i: any) => (
                              <MenuItem
                                sx={{
                                  // padding: "0 !important",
                                  fontSize: "12px !important",
                                }}
                                disabled={
                                  e.value == "new" || e.value == "pending"
                                }
                                key={e.value}
                                value={e.value}
                              >
                                {e.name}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                        {/* <Chip
                          label={row.status || "unknown"}
                          // label={feedbackDetails?.status || "open"}
                          sx={{
                            fontSize: "11px",
                            height: "25px",
                            textTransform: "capitalize",
                            ...renderStatusColorCss(row.status || "unknown"),
                            // ...renderStatusColorCss(feedbackDetails?.status || "open"),
                          }}
                        /> */}
                        {/* {row.status} */}
                      </TableCell>
                      <TableCell align="left">
                        {" "}
                        {userInfo?.userDetails?.userRole != ROLE_USER_MEMBER ? (
                          <Autocomplete
                            // className={
                            //   AssigneeIsloading
                            //     ? " chart-item loader"
                            //     : "chart-item"
                            // }
                            // open={assignDDOpen[row.id]}
                            onOpen={() => handleAssigneeOpen(row, row.id)}
                            onClose={() => setAssigneeOptions({})}
                            sx={{ p: "0 !important", minWidth: "180px" }}
                            size="small"
                            // freeSolo
                            value={
                              assignees[row.id] != null &&
                              assignees[row.id] != "" &&
                              assignees[row.id] != undefined
                                ? assignees[row.id]
                                : row?.assignee
                                ? renderValues(row.assignee.split("@")[0])
                                : ""
                            }
                            onChange={(event: any, newValue: any) =>
                              handleAssignChange(event, newValue, row.id)
                            }
                            disableClearable
                            // disablePortal={false}
                            options={checkandRenderOptions(
                              assigneeOptions,
                              row.id
                            )}
                            // loading={loading} // Optional: Use a loading state if needed
                            renderOption={(
                              props: any,
                              option: any,
                              key: any
                            ) => {
                              return (
                                <>
                                  <Grid
                                    {...props}
                                    container
                                    sx={{
                                      paddingRight: "0px !important",
                                      display: "flex",
                                      justifyContent:
                                        "space-between !important",
                                      // borderBottom: "1px solid",
                                      // borderColor: "rgba(0, 0, 0, 0.12)",
                                      // background: "none",
                                      // borderRadius: "8px 8px 0 0",
                                    }}
                                  >
                                    <Grid
                                      item
                                      xs={12}
                                      sm={4}
                                      md={4}
                                      lg={1.5}
                                      xl={1.5}
                                    >
                                      <Avatar
                                        sx={{
                                          width: 20,
                                          height: 20,
                                          fontSize: 9,
                                        }}
                                      >
                                        {option?.emailId &&
                                          option.emailId
                                            .charAt(0)
                                            .toUpperCase()}
                                      </Avatar>
                                    </Grid>
                                    <Grid
                                      sx={{
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                      }}
                                      item
                                      xs={12}
                                      sm={4}
                                      md={4}
                                      lg={8}
                                      xl={8}
                                    >
                                      {option.emailId}
                                      <BorderLinearProgress
                                        variant="determinate"
                                        value={
                                          (option.currCount / option.maxCount) *
                                            100 <=
                                          100
                                            ? (option.currCount /
                                                option.maxCount) *
                                              100
                                            : 100
                                        }
                                        // value={
                                        //   (option.currCount / option.maxCount) *
                                        //   100
                                        // } // Calculate the percentage value
                                        sx={{ mt: 1 }}
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={4}
                                      md={4}
                                      lg={2}
                                      xl={2}
                                    >
                                      {option.currCount + "/" + option.maxCount}
                                    </Grid>
                                  </Grid>
                                </>
                              );
                            }}
                            getOptionLabel={(option: any) => {
                              if (option) {
                                return option.name.split("@")[0];
                              }
                              return "";
                            }}
                            renderInput={(params: any) => (
                              <>
                                <TextField
                                  InputLabelProps={{ shrink: true }}
                                  sx={{ p: "0 !important" }}
                                  className="CuvoAssigneeTextField"
                                  placeholder="Unassigned"
                                  {...params}
                                  InputProps={{
                                    overrides: {
                                      MuiSelect: {
                                        icon: { position: "relative" },
                                      },
                                    },
                                    ...params.InputProps,
                                    title: params.inputProps.value,
                                    className: "limit-text-input", // Add a class for styling
                                    // Truncate the displayed value to a certain limit
                                    startAdornment: params.inputProps.value ? (
                                      <InputAdornment position="start">
                                        <Avatar
                                          className="emailsenderavatar"
                                          sx={{
                                            width: "25px !important",
                                            height: "25px !important",
                                            fontSize: "10px !important",
                                          }}
                                        >
                                          {row?.assignee &&
                                            row.assignee
                                              .charAt(0)
                                              .toUpperCase()}
                                        </Avatar>
                                      </InputAdornment>
                                    ) : (
                                      <InputAdornment position="start">
                                        <Avatar
                                          className="emailsenderavatar"
                                          sx={{
                                            width: "25px !important",
                                            height: "25px !important",
                                            fontSize: "10px !important",
                                          }}
                                        >
                                          <PersonAddAltIcon className="userAssignaddd" />
                                        </Avatar>
                                      </InputAdornment>
                                    ),
                                    // endAdornment: (
                                    // <InputAdornment position="end">
                                    //   <ArrowDropDownIcon
                                    //     sx={{ cursor: "pointer" }}
                                    //     onClick={() =>
                                    //       handleAssigneeOpen(row, row.id)
                                    //     }
                                    //   />
                                    // </InputAdornment>
                                    // ),
                                  }}
                                  variant="outlined"
                                  fullWidth
                                />
                              </>
                            )}
                          />
                        ) : (
                          <Typography
                            sx={{
                              color: `${
                                row?.assignee ? "#000000c7" : "#0000004a"
                              }`,
                              fontSize: "12px",
                              fontStyle: "normal",
                              lineHeight: "normal",
                            }}
                          >
                            {row?.assignee?.split("@")[0] || "Unassigned"}
                          </Typography>
                        )}
                        {/* <Avatar className="ticketAssigneeAvatr">
                        {/* {getFirstAndLastLetters(row.userId)} 
                      </Avatar> */}
                      </TableCell>
                      <TableCell
                        align="left"
                        onClick={() =>
                          redirectTicketReplyPage(
                            row,
                            "reply",
                            row.feedbackType,
                            row
                          )
                        }
                      >
                        <DateTime date={row.lastModifiedOn} useNewLine={true} />
                      </TableCell>
                      <TableCell
                        align="left"
                        onClick={() =>
                          redirectTicketReplyPage(
                            row,
                            "reply",
                            row.feedbackType,
                            row
                          )
                        }
                      >
                        <DateTime date={row.createdOn} useNewLine={true} />
                      </TableCell>
                      <TableCell>
                        {/* <IconButton> */}
                        <MoreVertIcon
                          onClick={(event) => {
                            handleMenuOpen(event, row);
                          }}
                        />
                        {/* </IconButton> */}
                        <Menu
                          sx={{
                            mt: "25px",
                            textTransform: "capitalize",
                          }}
                          anchorEl={anchorEl}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          className=" pro-menu copy-paste-popover"
                          keepMounted
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          PaperProps={{
                            elevation: 0,
                            sx: {
                              overflow: "visible",
                              boxShadow: "0px 1px 1px #dedede59",
                              filter: "drop-shadow(0px 1px 2px #dedede59)",
                              mt: 1.5,
                              "& .MuiMenu-list": {
                                pt: 0,
                              },
                              "& .MuiAvatar-root": {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                              },
                              "&:before": {
                                content: '""',
                                display: "block",
                                position: "absolute",
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: "background.paper",
                                transform: "translateY(-50%) rotate(45deg)",
                                zIndex: 0,
                              },
                            },
                          }}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                        >
                          {currProd.extSysVal &&
                          ((enableJira && userEnabledFeatures?.enableJira) ||
                            (enableZendesk &&
                              userEnabledFeatures?.enableZendesk)) ? (
                            <MenuItem
                              onClick={() =>
                                window.open(
                                  `${currProd.extSysVal?.url || ""}`,
                                  "_blank"
                                )
                              }
                              // onClick={() => handleEdit(currProd)}
                            >
                              <Box
                                className="read-more-link"
                                style={{ display: "inline-block" }}
                              >
                                <Typography
                                // onClick={() =>
                                //   window.open(
                                //     `${currProd.extSysVal?.url || ""}`,
                                //     "_blank"
                                //   )
                                // }
                                >
                                  {currProd.extSysVal.type} -{" "}
                                  {currProd.extSysVal.id}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ) : null}
                          {currProd.zendeskSysVal &&
                          // enableZendesk &&
                          //   enabledFeatures?.enableZendesk ?
                          enableZendesk &&
                          userEnabledFeatures?.enableZendesk ? (
                            <MenuItem
                              onClick={() =>
                                window.open(
                                  `${currProd.zendeskSysVal?.url || ""}`,
                                  "_blank"
                                )
                              }
                              // onClick={() => handleEdit(currProd)}
                            >
                              <Box
                                className="read-more-link"
                                style={{ display: "inline-block" }}
                              >
                                <Typography
                                // onClick={() =>
                                //   window.open(
                                //     `${currProd.zendeskSysVal?.url || ""}`,
                                //     "_blank"
                                //   )
                                // }
                                >
                                  {currProd.zendeskSysVal.type} -{" "}
                                  {currProd.zendeskSysVal.id}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ) : null}
                          {currProd.jiraSysVal &&
                          enableJira &&
                          userEnabledFeatures?.enableJira ? (
                            <MenuItem
                              onClick={() =>
                                window.open(
                                  `${currProd.jiraSysVal?.url || ""}`,
                                  "_blank"
                                )
                              }
                              // onClick={() => handleEdit(currProd)}
                            >
                              <Box
                                className="read-more-link"
                                style={{ display: "inline-block" }}
                              >
                                <Typography
                                // onClick={() =>
                                //   window.open(
                                //     `${currProd.jiraSysVal?.url || ""}`,
                                //     "_blank"
                                //   )
                                // }
                                >
                                  {currProd.jiraSysVal.type} -{" "}
                                  {currProd.jiraSysVal.id}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ) : null}

                          <MenuItem
                            disabled={true}
                            onClick={() => setDeletePopupOpen(true)}
                            // onClick={() => handleDelete(currProd.id)}
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableCell>
                      {/* <TableCell align="left">{row.platformInfo}</TableCell> */}
                    </TableRow>
                  );
                })}
              {/* {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 30, 40, 50]}
          component="div"
          count={tabledata?.Count || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        {/* {deletePopupOpen && (
          <DeleteDialog
            deletepopupShow={deletePopupOpen}
            deletepopupClose={handleClose}
            handleDeleteConfirm={deleteFeedback}
            type="feedback"
          />
        )} */}
        {showbulkEmailReplyEditor && (
          <BulkEmailReplyEditor
            feedbackIds={selected}
            feedbackFullDatas={feedbackFullDatas}
            closeBulkEmailReply={closeBulkEmailReply}
            lastEmailId={"dkdk"}
            lastEmailAvatar={"dd"}
            onDelete={[]}
            ticketId={"ticketId"}
            updateEmailList={"updateEmailList"}
            feedbackDetails={"feedbackDetails"}
            updateStatus={"updateStatus"}
            EmailSaluation={""}
            EmailSignature={""}
            setSelected={setSelected}
          />
        )}
      </Paper>
    </Box>
  );
};
export default withSnackbar(TicketsTable);
